import styled from "styled-components";
import { globalTheme } from "@cld/component-theme";

export const SectionBox = styled.section`
	padding: ${globalTheme.spacing.xs};
	border-bottom: 1px solid ${globalTheme.palette.secondary};
	position: relative;
	> label {
		font-weight: bold;
		white-space: nowrap;
		display: block;
		padding-bottom: ${globalTheme.spacing.xs};
	}
`;

export const LastSectionBox = styled(SectionBox)`
	border-bottom: 0px none;
`;
